<template>
  <div class="container">
    <div class="row py-5">
      <div class="col-sm-6"><h1 class="pstitle">New Boats</h1></div>
      <div class="col-sm-6 text-end">
        <a href="javascript:void(0)" class="pt-1 cursor" :onclick="resetFilter" aria-label="Reset Filters">Reset</a>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedModel"
          :value="selectedModel"
          :options="boatModels"
          :onchange="selectModel"
          id="model"
          class="form-control"
        />
        <label for="model" class="form-label">{{formLabel.model}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedYear"
          :value="selectedYear"
          :options="modelYears"
          :onchange="selectYear"
          id="year"
          class="form-control"
        />
        <label for="year" class="form-label">{{formLabel.year}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedPrice"
          :value="selectedPrice"
          :options="priceRanges"
          :onchange="selectPrice"
          id="price"
          class="form-control"
        />
        <label for="price" class="form-label">{{formLabel.price}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="sortBy"
          :value="sortBy"
          :options="sortOptions"
          :onchange="selectSortBy"
          id="sortBy"
          class="form-control"
        />
        <label for="sortBy" class="form-label">Sort By</label>
      </div>
    </div>
    <div class="row py-3">
      <div class="col-xs-12 col-sm-6 compare-boat">
        <a
          :href="'/Inventory/Compare?ids=' + this.selectedBoatId"
          :disabled="selectedBoatId.length > 1"
          v-if="selectedBoatId.length > 1"
          >Compare Boats</a
        >
        <span v-else>Compare Boats</span>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="text-end compare-boat">
            <a :href="website" target="_blank">View {{ brand }} Lineup</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-for="boat in boats.data"
        :key="boat.id"
        class="col-12 col-md-6 col-lg-3 mb-4 box"
      >
          <boat-card :boat="boat" :showCompare="true" :checkboxDisabled="isDisabled(boat)" @onCompareCheck="onCheckboxCheck($event)" @onCompareUncheck="onCheckboxUncheck($event)"></boat-card>
      </div>
      <div v-if="(boats == null || boats.data == null || boats.data.length == 0) && loading === false" class="col-12">
          <p>
              {{noBoatsLabel}}
          </p>
      </div>
      <div>
        <pagination
          v-model="this.boats.page"
          :records="this.boats.totalCount"
          :per-page="this.boats.pageSize"
          @paginate="getNextPage" 
          aria-label="Pagination" 
          edge-navigation ="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import getEndPoint, { newBoats, filterBoat } from "../constants/api.config";
import getBrandDetails from "../constants/brand.config";
import SelectOption from "../components/atoms/SelectOption.vue";
import Pagination from "v-pagination-3";
import { boatsPageSize, formLabel, noNewBoats } from "../constants/labels.config";
import BoatCard from "../components/atoms/BoatCard";

export default {
  name: "NewBoatPage",
  data() {
    return {
      brand: getBrandDetails(sessionStorage.getItem("brand"), "brandName"),
      website: getBrandDetails(sessionStorage.getItem("brand"), "brandUrl"),
      selectedBoatId: [],
      selectedModel: "Select Model",
      selectedYear: "Select Year",
      selectedPrice: "Select Price",
      sortBy: "Select Sort Option",
      boats: {
        totalCount: 0,
        pageCount: 0,
        page: 0,
        pageSize: 0,
        data: [],
      },
      boatsPageSize,
      boatModels: [],
      modelYears: [],
      priceRanges: [],
      sortOptions: [
        { value: "Select Sort Option" },
        { value: "Year - Newest to Oldest" },
        { value: "Price - High to Low" },
        { value: "Model - Descending" },
      ],
      filterPrice: [],
      loading: false,
      formLabel,
      noBoatsLabel: noNewBoats
    };
  },
  components: {
    SelectOption,
    Pagination,
    BoatCard
  },
  mounted() {
    this.getNewBoats(1);
    this.getBoatFilter();
  },
  methods: {
    getNextPage(event) {
      this.getNewBoats(event);
    },
    getNewBoats(pageNumber) {
      let model =
        this.selectedModel === "Select Model" ? "" : this.selectedModel;
      let year = this.selectedYear === "Select Year" ? "" : this.selectedYear;
      let sort = "&SortColumn=&SortDirection=";

      let minValue = "";
      let maxPrice = "";

      if (this.selectedPrice !== "Select Price") {
        const filteredPrice = this.filterPrice.filter(
          (item) => item.priceRangeLabel === this.selectedPrice
        );
        minValue = filteredPrice[0].minValue ? filteredPrice[0].minValue : "";
        maxPrice = filteredPrice[0].maxValue ? filteredPrice[0].maxValue : "";
      }

      if (this.selectedPrice !== "Select Price") {
        const filteredPrice = this.filterPrice.filter(
          (item) => item.priceRangeLabel === this.selectedPrice
        );
        minValue = filteredPrice[0].minValue ? filteredPrice[0].minValue : "";
        maxPrice = filteredPrice[0].maxValue ? filteredPrice[0].maxValue : "";
      }

      switch (this.sortBy) {
        case "Year - Newest to Oldest":
          sort = "&SortColumn=Year&SortDirection=desc";
          break;
        case "Price - High to Low":
          sort = "&SortColumn=Price&SortDirection=desc";
          break;
        case "Model - Descending":
          sort = "&SortColumn=Model&SortDirection=desc";
          break;
      }

      this.loading = true;
      this.axios
        .get(
          getEndPoint(newBoats) +
            "DealerLocationID=" +
            window.DEALER_LOCATION.dealerLocationID +
            "&Model=" +
            model +
            "&ModelYear=" +
            year +
            sort +
            "&MinPrice=" +
            minValue +
            "&MaxPrice=" +
            maxPrice +
            "&PageSize=" +
            this.boatsPageSize +
            "&PageNo=" +
            pageNumber
        )
        .then((response) => {
          this.loading = false;
          this.boats = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getBoatFilter() {
      this.axios
        .get(
          getEndPoint(filterBoat) +
            "IsUsed=false&DealerLocationID=" +
            window.DEALER_LOCATION.dealerLocationID
        )
        .then((response) => {
          let boatModel = response.data.models.map((item) => {
            return { value: item };
          });
          this.boatModels = [{ value: "Select Model" }, ...boatModel];

          let modelYear = response.data.modelYears.map((item) => {
            return { value: item };
          });
          this.modelYears = [{ value: "Select Year" }, ...modelYear];

          let priceRange = response.data.priceRanges.map((item) => {
            return { value: item.priceRangeLabel };
          });
          this.priceRanges = [{ value: "Select Price" }, ...priceRange];

          this.filterPrice = response.data.priceRanges;
        })
        .catch((err) => console.log(err));
    },
    resetFilter() {
      this.selectedModel = "Select Model";
      this.selectedYear = "Select Year";
      this.selectedPrice = "Select Price";
      this.sortBy = "Select Sort Option";
      this.getNewBoats(1);
    },
    selectModel(evt) {
      this.selectedModel = evt.target.value;
      this.getNewBoats(1);
    },
    selectYear(evt) {
      this.selectedYear = evt.target.value;
      this.getNewBoats(1);
    },
    selectPrice(evt) {
      this.selectedPrice = evt.target.value;
      this.getNewBoats(1);
    },
    selectSortBy(evt) {
      this.sortBy = evt.target.value;
      this.getNewBoats(1);
      },
    onCheckboxCheck(evt) {
        this.selectedBoatId.push(evt);
    },
    onCheckboxUncheck(evt) {
        this.selectedBoatId = this.selectedBoatId.filter(
            (item) => item !== evt
        );
      },
    isDisabled(boat) {
        if (!this.selectedBoatId.includes(boat.boatID) && this.selectedBoatId.length >= 4) {
            return true;
        }
        return false;
    }
  },
};
</script>
<style lang="scss">

.compare-boat span {
  cursor: not-allowed;
}

.form-control {
  appearance: auto;
}
img {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  display: block; /*remove extra space below image */
}
.box {
  display: flex;
  flex-direction: row;
}

</style>

